import type { RouteObject } from 'react-router-dom';

import { setPermissions } from '@/features/auth/authStore';
import { routes } from '@/router';
import { transformElegantRouteToReactRoute } from '@/router/common/transform';
import { PlatformAccountService } from '@/service/api/platform/index';
import type { MenuItemDto } from '@/service/api/platform/menu';
import { store } from '@/store';

import { getUserInfo } from '../auth';

interface InheritAttrs {
  sideShow?: boolean;
}
const routerDataHander = (treeList: MenuItemDto[], inheritAttrs: InheritAttrs = {}) => {
  const newTreeList: Router.RouterData[] = [];
  treeList.forEach(tree => {
    const newTree: Router.RouterData = {
      component: tree.component,
      errorBoundary: tree.errorBoundary,
      fallback: tree.fallback,
      handle: {
        activeMenu: tree.activeMenu,
        hideInMenu: inheritAttrs.sideShow === false ? true : !tree.sideShow,
        icon: tree.icon,
        title: tree.name
      },
      name: tree.mark,
      path: tree.pagePath,
      redirect: tree.redirect,
      type: tree.menuType
    };
    if (tree.children && tree.children.length) {
      newTree.children = routerDataHander(tree.children, {
        sideShow: !newTree.handle!.hideInMenu
      });
    }
    newTreeList.push(newTree);
  });
  return newTreeList;
};

export async function initAuthRoutes(addRoutes: (parent: string | null, route: RouteObject[]) => void) {
  await getUserInfo();
  const { data } = await PlatformAccountService.getMenus();
  const newMenus = routerDataHander(data!.menuList);
  store.dispatch(setPermissions(data!.permissionsList));
  addRoutes(
    'root',
    newMenus.flatMap(route => transformElegantRouteToReactRoute(routes[0], route))
  );
}
